<div #container class="col-xs-12 container">
    <canvas #canvas class="col-xs-12 canvas" (click)="openModal()"></canvas>
    <tt-button *ngIf="ttClear" (ttClick)="clear()" ttIcon="fas fa-eraser" ttType="primary"></tt-button>
</div>
